import BellIcon from '@assets/icons/bell.svg';
import BoxIcon from '@assets/icons/cardboard-box.svg';
import CalendarIcon from '@assets/icons/calendar.svg';
import GraphIcon from '@assets/icons/bar-graph.svg';
import React from 'react';
import SearchIcon from '@assets/icons/search.svg';
import { CannedQuestionCategory } from '@/contexts/canned-questions-context';
import {
  CircledIcon,
  Props as CircleIconProps,
} from '@/components/circled-icon';
import { createStyles } from '@/contexts/theme-context';
import { FONTS, TYPOGRAPHY } from '@/styles';
import {
  StyleProp,
  Text,
  TouchableOpacity,
  View,
  ViewStyle,
} from 'react-native';

interface Props {
  category: CannedQuestionCategory;
  containerStyle?: StyleProp<ViewStyle>;
  contentStyle?: StyleProp<ViewStyle>;
  onPress?: () => void;
  question: string;
  title: string;
}

export const CannedQuestion: React.FC<Props> = ({
  category,
  containerStyle = {},
  contentStyle = {},
  onPress,
  question,
  title,
}) => {
  const [styles, theme] = useStyles();

  const renderIconProps = (): Pick<
    CircleIconProps,
    'fill' | 'Icon' | 'stroke'
  > => {
    switch (category) {
      case CannedQuestionCategory.Fulfillment:
        return {
          fill: theme.colors.background,
          Icon: BoxIcon,
          stroke: theme.colors.primary,
        };
      case CannedQuestionCategory.OrderDate:
        return {
          fill: theme.colors.background,
          Icon: CalendarIcon,
          stroke: theme.colors.primary,
        };
      case CannedQuestionCategory.OrderPrice:
        return {
          fill: theme.colors.primary,
          Icon: GraphIcon,
        };
      case CannedQuestionCategory.SalesAlert:
        return {
          fill: null,
          Icon: BellIcon,
          stroke: theme.colors.primary,
        };
      case CannedQuestionCategory.Search:
        return {
          fill: theme.colors.primary,
          Icon: SearchIcon,
        };
      default:
        return {
          fill: theme.colors.primary,
          Icon: SearchIcon,
        };
    }
  };

  return (
    <TouchableOpacity onPress={onPress} style={containerStyle}>
      <View style={[styles.content, contentStyle]} testID="canned-question">
        <View style={styles.title}>
          <CircledIcon
            {...renderIconProps()}
            iconHeight={16}
            iconWidth={16}
            style={styles.icon}
          />
          <Text style={[TYPOGRAPHY.small, FONTS.primarySemiBold]}>{title}</Text>
        </View>
        <Text style={[TYPOGRAPHY.small, styles.questionCopy]}>{question}</Text>
      </View>
    </TouchableOpacity>
  );
};

const useStyles = createStyles((theme) => ({
  content: {
    borderColor: theme.colors.divider,
    borderRadius: 8,
    borderWidth: 1,
    gap: 4,
    padding: 16,
  },
  icon: {
    backgroundColor: theme.colors.background,
    borderWidth: 0,
    height: 24,
    width: 24,
  },
  questionCopy: {
    color: theme.sk.color.text.secondary,
  },
  title: {
    gap: 16,
  },
}));
